import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Api } from "src/core/services/api.services";
import { traducirDeBase64 } from "src/helper/toBase64";
import BcLoading from "src/shared/components/Bc-Loading/Bc-Loading";
import LayoutMain from "src/shared/layouts/LayoutMain/LayoutMain";

const getDownloadFile = async (payload: any) => {
  const { data } = await Api.postUrlFile(payload);
  return data;
};

const DownloadFile = () => {
  const { url } = useParams();

  if (url) console.log(traducirDeBase64(url));

  const urlParts = new URL(traducirDeBase64(url as string));
  console.log(urlParts);
  const objectKey = urlParts.pathname.substring(1).split("/")[1];

  const mutation = useMutation(getDownloadFile, {
    onSuccess: (data: any) => {
      console.log(data);
    },
  });

  useEffect(() => {
    mutation.mutate({ url: traducirDeBase64(url as string) });
  }, []);

  return (
    <LayoutMain idPage={`Documento`} titlePage={false} className="main-center">
      <section className="bc-container bc-card view-brief">
        <h1>Descarga de documento {decodeURIComponent(objectKey)}</h1>
        <p>Puedes descargar el documento en el siguiente boton:</p>
        {mutation.isLoading && <BcLoading messages={`Cargando archivo`} />}
        {mutation.isError && <h1>Error</h1>}
        {mutation.data && (
          <a
            className="bc-button-primary bc-button-small btn-to-home"
            href={mutation.data.url}
            download={objectKey}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar Archivo
          </a>
        )}
      </section>
    </LayoutMain>
  );
};

export default DownloadFile;
